// enums
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createKonvaShape;
    }
});
const _enums = require("../../lib/enums");
const _KonvaCircle = /*#__PURE__*/ _interop_require_default(require("./KonvaCircle.js"));
const _KonvaLine = /*#__PURE__*/ _interop_require_default(require("./KonvaLine.js"));
const _KonvaRectangle = /*#__PURE__*/ _interop_require_default(require("./KonvaRectangle.js"));
const _KonvaEllipse = /*#__PURE__*/ _interop_require_default(require("./KonvaEllipse.js"));
const _KonvaPolygon = /*#__PURE__*/ _interop_require_default(require("./KonvaPolygon.js"));
const _KonvaTextEditable = /*#__PURE__*/ _interop_require_default(require("./KonvaTextEditable.js"));
const _KonvaArrow = /*#__PURE__*/ _interop_require_default(require("./KonvaArrow.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function KonvaShape(shape = {}, config = {}) {
    switch(shape.type){
        case _enums.KonvaShapes.CIRCLE:
            return new _KonvaCircle.default(shape, config);
        case _enums.KonvaShapes.LINE:
            return new _KonvaLine.default(shape, config);
        case _enums.KonvaShapes.RECTANGLE:
            return new _KonvaRectangle.default(shape, config);
        case _enums.KonvaShapes.ELLIPSE:
            return new _KonvaEllipse.default(shape, config);
        case _enums.KonvaShapes.POLYGON:
            return (0, _KonvaPolygon.default)(shape, config);
        case _enums.KonvaShapes.ARROW:
            return new _KonvaArrow.default(shape, config);
        case _enums.KonvaShapes.TEXT:
            config.padding = 8;
            return new _KonvaTextEditable.default(shape, config);
        default:
            return null;
    }
}
function createKonvaShape({ shape, rotation, // event handlers
onMouseDown = ()=>{}, onMouseEnter = ()=>{}, onMouseOut = ()=>{}, onShapeTransform = ()=>{} }) {
    const isStandard = shape.isStandard ? true : false;
    const isVisible = shape.isVisible ? true : false;
    const handleShapeTransform = (e, shape = {})=>{
        const node = e.target;
        let points = [];
        switch(node.className){
            case _enums.KonvaShapes.CIRCLE:
                points = [
                    {
                        x: node.x(),
                        y: node.y()
                    }
                ];
                break;
            case _enums.KonvaShapes.LINE:
            case _enums.KonvaShapes.ARROW:
                // https://stackoverflow.com/a/57641487 - see SergioP @ Jun 1, 2021 at 16:00
                // https://stackoverflow.com/a/73662484
                // https://stackoverflow.com/a/67793914
                const tr = node.getTransform();
                const isDragging = node.scaleX() === 1 && node.scaleY() === 1;
                if (isDragging) {
                    /**
           * The issue dragging line shapes is that the value returned
           * on each update is the accumulative drag and not the dydx drag since last update
           */ const prevPos = node.attrs.lastPosition || {
                        x: 0,
                        y: 0
                    };
                    let nextPos = node.position();
                    const dx = (nextPos.x || prevPos.x) - prevPos.x;
                    const dy = (nextPos.y || prevPos.y) - prevPos.y;
                    node.attrs.lastPosition = {
                        x: nextPos.x || prevPos.x,
                        y: nextPos.y || prevPos.y
                    };
                    tr.translate(-nextPos.x + dx, -nextPos.y + dy);
                }
                // universal shape update (points array)
                points = shape.points.map((p)=>tr.point(p));
                // reset position manually
                node.setAttrs({
                    x: 0,
                    y: 0
                });
                break;
            case _enums.KonvaShapes.RECTANGLE:
            case _enums.KonvaShapes.TEXT:
                const newWidth = Math.abs(node.width() * node.scaleX());
                const newHeight = Math.abs(node.height() * node.scaleY());
                // update shape manually
                node.setAttrs({
                    x: node.x(),
                    y: node.y(),
                    width: newWidth,
                    height: newHeight
                });
                // universal shape update (points array)
                points = [
                    {
                        x: node.x(),
                        y: node.y()
                    },
                    {
                        x: node.x() + newWidth,
                        y: node.y() + newHeight
                    }
                ];
                break;
            case _enums.KonvaShapes.ELLIPSE:
                const newRadiusX = Math.abs(node.radiusX() * node.scaleX());
                const newRadiusY = Math.abs(node.radiusY() * node.scaleY());
                // update shape manually
                node.setAttrs({
                    x: node.x(),
                    y: node.y(),
                    radiusX: newRadiusX,
                    radiusY: newRadiusY
                });
                // universal shape update (points array)
                points = [
                    {
                        x: node.x() - newRadiusX,
                        y: node.y() - newRadiusY
                    },
                    {
                        x: node.x() + newRadiusX,
                        y: node.y() + newRadiusY
                    }
                ];
                break;
            default:
                break;
        }
        // Reset transform scale
        node.setAttrs({
            scaleX: 1,
            scaleY: 1
        });
        // update imageInfo
        onShapeTransform(_object_spread_props(_object_spread({}, shape), {
            points
        }));
    };
    const handleTransformEnd = (e)=>{
        const node = e.target;
        if (node) {
            // Force redraw on transform end
            // Required to prevent label hover from caching transformer
            node.getStage().batchDraw();
        // node.getStage().find("Transformer")[0].forceUpdate();
        }
    };
    const handleTextChange = (text = "", shape)=>{
        onShapeTransform(_object_spread_props(_object_spread({}, shape), {
            label: text
        }));
    };
    const handleDragStart = (e)=>{
        const node = e.target;
        const lastPosition = node.position();
        node.attrs.lastPosition = lastPosition;
    };
    // transform konva shape
    const konvaShape = KonvaShape(shape, // props -->
    {
        rotation,
        strokeEnabled: true,
        strokeWidth: 4,
        draggable: !isStandard,
        listening: !isStandard,
        editable: !isStandard,
        visible: isVisible,
        // callbacks -->
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onMouseDown,
        onDragStart: handleDragStart,
        onDragMove: handleShapeTransform,
        onTransform: handleShapeTransform,
        onTransformEnd: handleTransformEnd,
        onTextChange: handleTextChange
    });
    // add konva shape to its own transform group
    if (konvaShape) {
        return konvaShape;
    }
}
